export const REGISTER = "/useraccount/register/";
export const LOGIN = "/useraccount/login/";
export const GET_USERS = "/useraccount/admin/users/";
export const UPDATE_USERS = "/useraccount/admin/users/";
export const POST_VIRALADS = "/viralad/upload_template/";
export const GET_ROLES = "/useraccount/get-user-roles/";
export const GET_BCC = "/viralad/get/brand_or_category/"
export const GET_STATUS = '/useraccount/get-user-status-choices/'
export const UPDATE_USER_STATUS = "/useraccount/admin/users/"